import { Dispatch } from "redux";

import { auth } from "../../services";
import { AuthTypes, LoginParams } from "./types";
import * as actions from "./actions";
import history from "../../history";
import { closeSnackbar, enqueueSnackbar } from "../toast/actions";

// export const register = ({ email, password1, password2 }: RegisterParams) => {
//   return async (dispatch: Dispatch) => {
//     dispatch(actions.authRequest(AuthTypes.REGISTER.REQUEST));

//     try {
//       const response = await auth().authSignup(email, password1, password2);
//       const { token, user } = response.data;
//       if (token) {
//         // TODO: redirect user to confirm email
//         // history.push(`/register/account-confirm-email/:key`)
//         dispatch(actions.authSuccess(token, user, AuthTypes.REGISTER.SUCCESS));
//       } else if (response.status === 401) {
//         dispatch(actions.authFailure(AuthTypes.AUTH_REQUEST_UNAUTHORIZED));
//       }
//     } catch (error) {
//       console.log(error);
//       dispatch(actions.authFailure(AuthTypes.REGISTER.FAILURE));
//     }
//   };
// };

export const login = ({ email, password }: LoginParams) => {
  return async (dispatch: Dispatch | any) => {
    dispatch(actions.authRequest(AuthTypes.LOGIN.REQUEST));

    try {
      const response = await auth().authLogin(email, password);
      const { token, user } = response.data;
      if (token && response.status === 200) {
        dispatch(actions.authSuccess(token, user, AuthTypes.LOGIN.SUCCESS));
        // close all notifications if session was expired before
        dispatch(closeSnackbar());
      }
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        dispatch(
          actions.authFailure(AuthTypes.LOGIN.FAILURE, error.response.data)
        );
      }
    }
  };
};

export const resendVerificationEmail = (email: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: AuthTypes.RESEND_VERIFICATION_EMAIL.REQUEST });

    try {
      const response = await auth().resendVerificationEmail(email);
      if (response.status === 202)
        dispatch({ type: AuthTypes.RESEND_VERIFICATION_EMAIL.SUCCESS });
    } catch (error: string | any) {
      dispatch({ type: AuthTypes.RESEND_VERIFICATION_EMAIL.FAILURE });
    }
  };
};

export const requestPassReset = (email: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.authRequest(AuthTypes.REQUEST_RESET_PASSWORD.REQUEST));

    try {
      const response = await auth().requestPassReset(email);
      if (response.status === 200)
        dispatch({ type: AuthTypes.REQUEST_RESET_PASSWORD.SUCCESS });
    } catch (error: string | any) {
      dispatch(actions.authFailure(AuthTypes.REQUEST_RESET_PASSWORD.FAILURE));
    }
  };
};

export const resetPassword = (
  newPass1: string,
  confirmPass: string,
  uid: string,
  token: string
) => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.authRequest(AuthTypes.RESET_PASSWORD.REQUEST));

    try {
      const response = await auth().resetPassword(
        newPass1,
        confirmPass,
        uid,
        token
      );
      if (response.status === 200)
        dispatch({ type: AuthTypes.RESET_PASSWORD.SUCCESS });
    } catch (error: string | any) {
      dispatch(actions.authFailure(AuthTypes.RESET_PASSWORD.FAILURE));
    }
  };
};

export const logout = () => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.authLogout());

    await auth().authLogout();

    history.push("/auth");
    window.localStorage.clear();
  };
};

export const passwordChange = (
  oldPass: string,
  newPass1: string,
  newPass2: string
) => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.authRequest(AuthTypes.CHANGE_PASSWORD.REQUEST));

    try {
      const response = await auth().passwdChange(oldPass, newPass1, newPass2);

      dispatch({ type: AuthTypes.CHANGE_PASSWORD.SUCCESS, payload: response });
      dispatch(
        enqueueSnackbar({
          message: "Your password was changed successfully",
          options: {
            variant: "success",
          },
        })
      );
    } catch (error: any) {
      if (error.response) {
        dispatch(
          actions.authFailure(
            AuthTypes.CHANGE_PASSWORD.FAILURE,
            error.response.data
          )
        );
      }
    }
  };
};
